import { useCallback, useState } from "react";

export const useBoolState = (initial: boolean) => {
  const [value, setValue] = useState(initial);

  const startValue = useCallback(() => {
    setValue(true);
  }, [setValue]);

  const endValue = useCallback(() => {
    setValue(false);
  }, [setValue]);

  return [value, startValue, endValue] as const;
};
